import { render } from "./crashDemo.vue?vue&type=template&id=8564738a&scoped=true"
import script from "./crashDemo.vue?vue&type=script&lang=js"
export * from "./crashDemo.vue?vue&type=script&lang=js"

import "./crashDemo.vue?vue&type=style&index=0&id=8564738a&scoped=true&lang=css"
import "./crashDemo.vue?vue&type=style&index=1&id=8564738a&lang=css"
import "./crashDemo.vue?vue&type=style&index=2&id=8564738a&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8564738a"]])

export default __exports__